import styled from 'styled-components'

interface ISectionProps {
  backgroundColor?: string
  backgroundImage?: string
  column?: boolean
  topPadding?: number
  bottomPadding?: number
  leftPadding?: number
  rightPadding?: number
  mobilePadding?: string
  tabletPadding?: string
  desktopPadding?: string
  desktopLargePadding?: string
  noPadding?: boolean
  inset?: boolean
  background?: string
  tabletBackground?: string
  desktopBackground?: string
}

const Section = styled.div<ISectionProps>`
  display: flex;
  flex-direction: ${props => (props.column ? 'column' : 'row')};
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100%;
  padding: 40px ${props => props.theme.metrics.gutterPhone}px;
  ${props => props.mobilePadding && `padding: ${props.mobilePadding};`}
  background-color: ${props => props.backgroundColor || props.theme.colors.transparent};
  ${props => props.background && `background: ${props.background};`}
  ${props => props.backgroundImage && `background: center/cover url(${props.backgroundImage});`}
  ${props => props.noPadding && 'padding: 0;'}
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding: 40px ${props => props.theme.metrics.gutterPhone}px;
    ${props => props.tabletPadding && `padding: ${props.tabletPadding}`};
    ${props => props.inset && 'margin: 20px; width: calc(100vw - 40px);'}
    ${props => props.bottomPadding && `padding-bottom: ${props.bottomPadding}px;`}
    ${props => props.topPadding && `padding-top: ${props.topPadding}px;`}
    ${props => props.leftPadding && `padding-left: ${props.leftPadding}px;`}
    ${props => props.rightPadding && `padding-right: ${props.rightPadding}px;`}
    ${props => props.noPadding && 'padding: 0;'}
    ${props => props.tabletBackground && `background: ${props.tabletBackground};`}
  }
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    padding: 40px 70px;
    ${props => props.desktopPadding && `padding: ${props.desktopPadding}`};
    ${props => props.noPadding && 'padding: 0;'}
    ${props => props.desktopBackground && `background: ${props.desktopBackground};`}
  }
  @media (min-width: ${props => props.theme.metrics.desktopLarge}px) {
    padding: 40px 70px;
    ${props => props.desktopLargePadding && `padding: ${props.desktopLargePadding}`};
    ${props => props.noPadding && 'padding: 0;'}
  }
`
export default Section
